<section class="cart-overview-wrapper">
    <h1 class="heading-3">
        <i class="fa-solid fa-cart-shopping margin-right-8" aria-hidden="true"></i>{{'cart.overview.your_cart' | translate}}
        <span> ({{cart?.totalQuantity}} {{getItemsTotalQuantityTag(cart?.totalQuantity) | translate}})</span>
    </h1>
    <div class="cart-overview-actions" *ngIf="showSaveAsShareList">
        <div class="cart-overview-actions__slot">
            <button class="button button-large button-secondary btn-spinner-outer"
                    [disabled]="saveAsShareListBusy || !checkoutAvailable"
                    (click)="saveCartAsShareList()" data-testid="cartSaveAsShareListButton">
                <button-spinner [buttonTranslate]="'cart.save.as.share.list'" [isBusy]="saveAsShareListBusy"></button-spinner>
            </button>
        </div>
        <div class="cart-overview-actions__spacer" aria-hidden="true"></div>
    </div>
    <div class="cart-overview-container">
        <div class="flex-col-left">
            <div class="product-summary-container">
                <ng-container *ngTemplateOutlet="notifications"></ng-container>
                <div class="cart-product-summary">
                    @if (cart?.products.length > 0) {
                        <cart-product-summary [customerType]="customerType"></cart-product-summary>
                    } @else {
                        <div class="empty-cart">
                            <span class="margin-right-8" translate="cart.empty.cart.message"></span>
                            @if (!nfrMhpShoppingOnly) {
                                <a [routerLink]="LANDING_ROUTE" translate="cart.empty.cart.shop.now"></a>
                            }
                        </div>
                    }
                </div>
            </div>
            @if (allowCartSaveForLater && saveForLaterProducts?.length >= 1) {
                <div class="save-for-later-container">
                    <h2 class="heading-3">
                        <i class="fa-solid fa-bookmark margin-top-8"></i> {{ 'cart.product.save.for.later.title' | translate }}<span> ({{ saveForLaterProducts.length }} {{getItemsTotalQuantityTag(saveForLaterProducts.length) | translate}})</span>
                    </h2>
                    <div class="product-summary-container">
                        <div class="cart-product-summary">
                            <cart-saved-product></cart-saved-product>
                        </div>
                    </div>
                </div>
            }
        </div>
        <div class="price-summary-container">
            <ng-container *ngTemplateOutlet="notifications"></ng-container>
            <div class="price-container">
                <div class="cart-price-summary">
                    <h3 class="heading-4">
                        {{ 'cart.overview.cart.summary' | translate }}
                    </h3>
                    <div class="subtotal-container">
                        <table>
                            <tr>
                                <td>{{'cart.order.total' | translate}}</td>
                                <td data-testid="cart.order.total.value">{{(showCartPriceBreakdown ? cart?.preDiscountTotal : cart?.totalPrice) | usanacurrency | async}}</td>
                            </tr>
                            @if (shouldDisplayVolume) {
                                <tr>
                                    <td>{{'cart.order.total.volume' | translate }}</td>
                                    <td data-testid="cart.order.total.volume.value">{{cart?.totalVolume}}</td>
                                </tr>
                            }
                            @if (showCartPriceBreakdown && (cart?.attributionDiscount > 0 || cart?.subscriptionDiscount > 0)) {
                                <tr class="line-discount">
                                    <td colspan="2">{{'cart.order.totals.discounts' | translate}}</td>
                                </tr>
                                @if (cart?.attributionDiscount > 0) {
                                    <tr class="line-discount">
                                        <td>
                                            @if (showSponsorCode) {
                                                <span [translate]="'cart.checkout.code.applied'" [key]="'code'" [interpolate]="sponsorName"></span>
                                            } @else {
                                                <span [translate]="'cart.checkout.code.' + customerType"></span>
                                            }
                                        </td>
                                        <td data-testid="cart.order.discounts.value">{{cart?.attributionDiscount | usanacurrency | async}}</td>
                                    </tr>
                                }
                                @if (cart?.subscriptionDiscount > 0) {
                                    <tr class="line-discount">
                                        <td>{{'cart.order.totals.subscription.discount' | translate}}</td>
                                        <td data-testid="cart.order.subscription.discount.value">{{cart?.subscriptionDiscount | usanacurrency | async}}</td>
                                    </tr>
                                }
                            }
                            @if (!limitedShopping) {
                                <tr>
                                    <td>{{'cart.order.totals.tax' | translate}}</td>
                                    <ng-container *ngTemplateOutlet="hideTotalsTemplate"></ng-container>
                                </tr>
                                <tr>
                                    <td>{{'cart.order.totals.shipping' | translate}}</td>
                                    <ng-container *ngTemplateOutlet="hideTotalsTemplate"></ng-container>
                                </tr>
                            }
                            @if (showCartPriceBreakdown) {
                                <tr class="grand-total">
                                    <td>{{'cart.order.totals.total' | translate}}</td>
                                    <td data-testid="cart.order.grandtotal.value">{{cart?.orderTotal | usanacurrency | async}}</td>
                                </tr>
                            }
                        </table>
                    </div>

                    @if (allowIor && cart) {
                        <ior [cart]="cart"></ior>
                    }
                    <ao-upsell></ao-upsell>

                    <button class="button button-large button-primary btn-spinner-outer"
                            [disabled]="!checkoutAvailable"
                            (click)="checkout()" data-testid="cartCheckoutButton">
                        <button-spinner [buttonTranslate]="'cart.checkout'" [isBusy]="checkoutButtonClicked"></button-spinner>
                    </button>
                </div>
            </div>
        </div>
    </div>
</section>

<ng-template #notifications>
    <div class="cart-notification-container">
        <div class="notification notification-info" *ngIf="showShareListArrivalBanner">
            <i class="fa-solid fa-circle-dot margin-right-8" aria-hidden="true"></i>
            <span>
                <span *ngIf="shareListArrivalSponsorName" translate="cart.shareable.arrival.sponsor.message" [interpolate]="{name: shareListArrivalSponsorName}"></span>
                <span *ngIf="!shareListArrivalSponsorName" translate="cart.shareable.arrival.message"></span>
            </span>
            <button [attr.aria-label]="'cart.button.close' | translate" class="fa-solid fa-xmark" type="button" (click)="showShareListArrivalBanner = false;"></button>
        </div>
        @if (showWillCallOnlyMessage) {
            <div class="notification notification-alert">
                <span translate="cart.order.will.call.only"></span>
                <button [attr.aria-label]="'cart.button.close'| translate" class="fa-solid fa-xmark" type="button" (click)="hideWillCall = true;"></button>
            </div>
        }
        @if (!!freeShippingMessage && !hideFreeShippingMessage) {
            <div class="notification" [ngClass]="freeShippingMessage.qualifyingThreshold? 'notification-success': 'notification-info'"
                 [attr.data-testid]="freeShippingMessage.qualifyingThreshold ? 'cart.order.freeshipping.message.freeshippingachieved' : 'cart.order.freeshipping.message.amountawayfromfreeshipping'">
                {{freeShippingMessage.messageDisplay}}
                <button [attr.aria-label]="'cart.button.close'| translate" class="fa-solid fa-xmark" type="button" (click)="hideFreeShippingMessage = true;"></button>
            </div>
        }
        @if (showRenewalFeeMessage) {
            <div class="notification notification-alert">
                <customer-service [preText]="'cart.renewal.fee.added.to.cart'"></customer-service>
                <button [attr.aria-label]="'cart.button.close'| translate" class="fa-solid fa-xmark" type="button" (click)="showRenewalFeeMessage = false;"></button>
            </div>
        }
        @if (!!productCreditBalanceText && !hideProductCreditBalanceText) {
            <div class="notification notification-info">
                {{productCreditBalanceText}}
                <button [attr.aria-label]="'cart.button.close'| translate" class="fa-solid fa-xmark" type="button" (click)="hideProductCreditBalanceText = true;"></button>
            </div>
        }
    </div>
</ng-template>

<ng-template #hideTotalsTemplate>
    <td>----</td>
</ng-template>
